import { createTheme } from '@material-ui/core/styles';

export const MainTheme = createTheme({
  palette: {
    primary: {
      main: '#00539d',
    },
    secondary: {
      main: '#f59419',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
});
